module.exports = __webpack_public_path__ + "images/correction-studio-guest-background-b862de28d19a0b9fa3082cd6852bdd62.jpg";